import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NMI_CONFIG, NmiConfig } from './nmi.config';
import { NmiPaymentService } from './services/nmi-payment.service';
import { NmiInvoiceService } from './services/nmi-invoice.service';
import { NmiPaymentMethodService } from './services/nmi-payment-method.service';

function nmiProviders(config: NmiConfig): Provider[] {
  return [
    { provide: NmiPaymentService,       useFactory: (h: HttpClient) => new NmiPaymentService(h, config),       deps: [HttpClient] },
    { provide: NmiInvoiceService,       useFactory: (h: HttpClient) => new NmiInvoiceService(h, config),       deps: [HttpClient] },
    { provide: NmiPaymentMethodService, useFactory: (h: HttpClient) => new NmiPaymentMethodService(h, config), deps: [HttpClient] },
  ];
}

/**
 * For standalone Angular apps (app.config.ts):
 *
 *   import { provideHttpClient, withInterceptors } from '@angular/common/http';
 *   import { provideNmi, nmiAuthInterceptorFn } from '@cmbsolutions/nmi-angular';
 *   import store from 'store2';
 *
 *   export const appConfig: ApplicationConfig = {
 *     providers: [
 *       provideHttpClient(
 *         withInterceptors([AuthIInterceptor, nmiAuthInterceptorFn])
 *       ),
 *       provideNmi({
 *         apiUrl: 'https://your-nmi-api.com',
 *         tokenFn: () => store.get('token') as string,
 *         branchId: () => store.get('userbranches') as string,
 *       }),
 *     ]
 *   };
 */
export function provideNmi(config: NmiConfig): Provider[] {
  return [
    { provide: NMI_CONFIG, useValue: config },
    ...nmiProviders(config),
  ];
}

/**
 * For NgModule-based apps (app.module.ts):
 *
 *   NmiModule.forRoot({ apiUrl: '...', tokenFn: () => store.get('token') })
 *   Also add nmiAuthInterceptorFn to HTTP_INTERCEPTORS manually.
 */
@NgModule({})
export class NmiModule {
  static forRoot(config: NmiConfig): ModuleWithProviders<NmiModule> {
    return {
      ngModule: NmiModule,
      providers: [
        { provide: NMI_CONFIG, useValue: config },
        ...nmiProviders(config),
      ],
    };
  }
}
